import React from 'react';

// Legacy class exports kept for backward compatibility (CadastrarPedido, AlterarPedido)
export const inputCls =
  'block w-full h-11 px-3.5 text-sm text-slate-700 bg-white border border-slate-200 rounded-lg ' +
  'focus:outline-none focus:border-[#1e3a4c] focus:ring-1 focus:ring-[#edf6fb] mt-1';

export const selectCls =
  'block w-full h-11 px-3.5 text-sm text-slate-700 bg-white border border-slate-200 rounded-lg ' +
  'focus:outline-none focus:border-[#1e3a4c] focus:ring-1 focus:ring-[#edf6fb] mt-1 cursor-pointer';

export const textareaCls =
  'block w-full px-3.5 py-2.5 text-sm text-slate-700 bg-white border border-slate-200 rounded-lg ' +
  'focus:outline-none focus:border-[#1e3a4c] focus:ring-1 focus:ring-[#edf6fb] mt-1 min-h-[80px]';

export const chipFieldCls =
  'flex flex-wrap items-center min-h-[44px] px-3 py-1.5 border border-slate-200 rounded-lg w-full mt-1 cursor-pointer gap-1 bg-white';

export const disabledInputCls =
  'block w-full h-11 px-3.5 text-sm text-slate-400 bg-slate-50 border border-slate-200 rounded-lg mt-1 cursor-not-allowed';

export const modalSx = {
  position: 'absolute', top: '50%', left: '50%',
  transform: 'translate(-50%, -50%)', width: 440,
  bgcolor: '#fff', borderRadius: '6px',
  border: '1.5px solid #e2e8f0',
  boxShadow: '0 20px 60px rgba(0,0,0,0.13)', p: 4,
};

export const Field = ({ label, required, children }) => (
  <div style={{ width: '100%' }}>
    <div style={{ fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 6, letterSpacing: 0.2 }}>
      {label}{required && <span style={{ color: '#ef4444', marginLeft: 2 }}>*</span>}
    </div>
    {children}
  </div>
);

export const SubmitBtn = ({ children, onClick, type }) => (
  <button
    type={type || 'button'}
    onClick={onClick}
    style={{
      width: '100%', height: 48, borderRadius: 4,
      background: '#10b981',
      color: '#fff', border: 'none', fontWeight: 600, fontSize: 14,
      cursor: 'pointer', letterSpacing: 0.2, marginTop: 8,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      transition: 'opacity 0.15s',
    }}
    onMouseEnter={e => { e.currentTarget.style.background = '#059669'; }}
    onMouseLeave={e => { e.currentTarget.style.background = '#10b981'; }}
  >
    {children}
  </button>
);

export const SecondaryBtn = ({ children, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      width: '100%', height: 48, borderRadius: 4,
      background: 'transparent', color: '#5294b5',
      border: '1.5px solid #bbd8ea', fontWeight: 600, fontSize: 14, cursor: 'pointer',
      transition: 'background 0.15s',
    }}
    onMouseEnter={e => { e.currentTarget.style.background = '#edf6fb'; }}
    onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
  >
    {children}
  </button>
);

const FormLayout = ({ title, icon, subtitle, children, fullPage }) => {
  const outerStyle = fullPage
    ? { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '20px', background: '#f8fafc' }
    : { width: '100%', padding: '28px 24px 48px' };

  return (
    <div style={outerStyle}>
      <div style={{
        width: '100%',
        maxWidth: fullPage ? 460 : '100%',
        margin: '0 auto',
        background: '#fff',
        borderRadius: 6,
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
      }}>
        {/* Body */}
        <div style={{ padding: '26px 36px 36px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormLayout;
